import { Modules } from '@/enum/modules.js';
import { ElementoBase } from '@/enum/elemento_base.js';

export const moduleNameMap = {
  [Modules.SOLICITUD]: 'Solicitud',
  [Modules.COTIZACION]: 'Cotizacion',
  [Modules.ESPECIFICACION_TECNICA]: 'EspecificacionTecnica',
  [Modules.ORDEN_PRODUCCION]: 'OrdenProduccion',
};

export const componentBaseMap = {
  [Modules.SOLICITUD]: 'Request',
  [Modules.COTIZACION]: 'Price',
  [Modules.ESPECIFICACION_TECNICA]: 'TechnicalSpecification',
  [Modules.ORDEN_PRODUCCION]: 'WorkOrder',
};

export const componentNameMap = {
  [ElementoBase.ETIQUETA]: 'Label',
  [ElementoBase.TERMO_ENCOGIBLE]: 'TermoEncogibleLabel',
  [ElementoBase.FLEXIBLE]: 'FlexiblePackaging',
  [ElementoBase.CONSUMIBLE]: 'ConsumibleLabel',
  [ElementoBase.CAJA]: 'Cajas',
  [ElementoBase.LIBRO_TAPA]: 'Book',
  [ElementoBase.LIBRO_INTERNO]: 'BookInner',
  [ElementoBase.EXTRUSION]: 'Extrusion',
  [ElementoBase.BOLSAS_FUELLE]: 'BolsasFuelle',
  [ElementoBase.BOLSAS_BOX]: 'BolsasBox',
  [ElementoBase.OFFSET]: 'Offset',
};

export const getModuleName = (moduleValue) => {
  return moduleNameMap[moduleValue];
};

export const getComponentListByModule = (moduleValue) => {
  const baseName = componentBaseMap[moduleValue];

  // Validar que el módulo existe
  if (!baseName) {
    throw new Error(`Código de módulo inválido o inexistente: ${moduleValue}`);
  }

  return Object.entries(componentNameMap).map(([key, value]) => {
    return { id: Number(key), componentNameEdit: `${baseName}${value}` };
  });
};
